import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import {
  downloadAudienceBuilder,
  sendAudienceIntegrationJob,
} from '../../store/actions/audienceBuilder-actions';



const ActivateAudience = props => {
  const dispatch = useDispatch();

  const [downloadItem, setDownLoadItem] = useState(0);
  const [switchValue, setSwitchValue] = useState(false);
  const [downloadName, setDownloadName] = useState('');
  const [integration, setIntegration] = useState(null);

  const [visible, setvisible] = useState(false);

  const radioButtonArray = [
    'Customer ID',
    'Advertising ID',
    'Advertising ID - iOS',
    'Advertising ID - Android',
  ];

  const audienceId = useSelector(state => state.audienceBuilder.audienceId);

  const getParams = type => {
    let identifierName;
    let os;

    switch (downloadItem) {
      case 0:
        identifierName = 'customerId';
        os = 'all';
        break;
      case 1:
        identifierName = 'deviceId';
        os = 'all';
        break;
      case 2:
        identifierName = 'deviceId';
        os = 'iOS';
        break;
      case 3:
        identifierName = 'deviceId';
        os = 'Android';
        break;

      default:
        break;
    }

    const params = {
      audienceId,
      identifierName,
      os,
      filename: downloadName,
      excludeAdTrackingDisabled: switchValue,
    };

    if (type === 'integration') {
      params.integrationId = integration.integrationId;
      params.jobParams = {};

      integration.jobParams.map(item => {
        const newName = document.getElementById(item.name);
        params.jobParams[item.name] = newName.value;
      });

    }

    return params;
  };

  const handleDownloadButton = () => {
    const params = getParams('download');
    setvisible(true);
    dispatch(downloadAudienceBuilder(params));
  };

  const handleIntegrationChange = e => {
    setIntegration(e);
  };

  const sendIntegration = () => {
    const params = getParams('integration');
    dispatch(sendAudienceIntegrationJob(params));
  };

  const integrationButtonDisable = () => {

    if(integration !== null){

      let nodelist = document.getElementsByName("integrationInput");

      if(nodelist.length > 0 ){

        return false
      }

    }

    return integration === null;
  };

  const handleInputChange = (event) => {
    let nodelist = document.getElementsByName("integrationInput");
    integrationButtonDisable()
  }



  return (
    <div className="content-card">
      <div className="Audience_content_modal-area">
        <div className="Audience_content_modal-area_title">
          Download csv file
        </div>
        <div className="Audience_content_modal-area_title">
          Send to Integration
        </div>

        <div
          className="Audience_content_modal-area_content"
          style={{ borderRight: '1px solid #d6dee9' }}
        >
          <h3 style={{ fontSize: '1rem', color: '#697689' }}>File Name</h3>
          <input
            className="Audience_content_modal-area_content_input"
            type="text"
            id="Add-campaign_name"
            value={downloadName}
            onChange={e => setDownloadName(e.target.value)}
          />

          <div style={{ marginTop: '3rem' }}>
            {radioButtonArray.map((item, idx) => (
              <label
                className="radio_container"
                style={{
                  fontSize: '18px',
                  color: '#697689',
                  lineHeight: '1.4rem',
                  marginBottom: '13px',
                }}
              >
                {item}
                <input
                  type="radio"
                  checked={downloadItem === idx}
                  onClick={() => setDownLoadItem(idx)}
                />
                <span className="radio_checkmark" />
              </label>
            ))}
            <div className="Audience_content_modal-area_switch-area">
            <div className="Audience_content_modal-area_switch-area_switch">
              <AntSwitch
                checked={switchValue}
                onChange={() => setSwitchValue(!switchValue)}
                name="checked"
              />
            </div>
            <div className="Audience_content_modal-area_switch-area_description">
              <span style={{ color: '#697689' }}>
                Exclude devices that have opted out of Advertising Tracking
              </span>
            </div>
            </div>

            <div style={{ marginTop: '2rem', textAlign: 'center' }}>
              <button
                onClick={() => handleDownloadButton()}
                className="Header_create-location-insights-button"
                disabled={downloadName === ''}
                style={{
                  backgroundColor: downloadName === '' ? '#CCC' : '#32ABE1',
                }}
              >
                Download
              </button>
            </div>
          </div>
        </div>

        <div className="Audience_content_modal-area_content">
          <h3 style={{ fontSize: '1rem', color: '#697689' }}>
            Select Integration
          </h3>

          <Select
            inputId="criteria-modal-select-organisation"
            className="CriteriaModal_search-organisation-input"
            classNamePrefix="CriteriaModal_search-organisation-input_"
            placeholder="Type to search"
            isDisabled={false}
            isClearable
            isLoading={!props.integrationsLoaded}
            isRtl={false}
            isSearchable
            name="integration"
            value={integration}
            options={props.integrations.map(item =>{
              return ({
                label: item.target.name,
                value: item.target.id,
                jobParams: item.target.jobParams,
                integrationId: item.id
              })
            })}
            onChange={event => handleIntegrationChange(event)}
          />

          <div className="Audience_content_modal-area_integration-list">
            {integration !== null && (
              <div className="Audience_content_modal-area_integration-list_item">

                  {integration.jobParams.map(item => (
                    <form>
                      {item.name}
                      <input
                        className="Audience_content_modal-area_content_input"
                        type="text"
                        name='integrationInput'
                        id={item.name}
                        onChange={handleInputChange}
                      />
                      <span className="Audience_content_modal-area_description">
                        {item.description}
                      </span>
                    </form>
                  ))}

              </div>
            )}
          </div>

          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <button
              onClick={() => sendIntegration()}
              className="Header_create-location-insights-button"
              disabled={integrationButtonDisable()}
              style={{
                backgroundColor: integration === null ? '#CCC' : '#32ABE1',
              }}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivateAudience;

const AntSwitch = withStyles(theme => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: '#06B5FB',
        borderColor: '#06B5FB',
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
  openLabelColor: {
    color: 'black',
  },
}))(Switch);
